<div class="align-items-center justify-content-left" style="width: 100%;">
    <input ngx-google-places-autocomplete
        #placesRef="ngx-places"
        (onAddressChange)="handleAddressChange($event)"
        class="form-control input-sm"
        id="address-{{ randId }}"
        placeholder="{{ 'SHARED.PLEASE_ENTER_ADDRESS' | translate }}" />
    <i class="fa fa-close text-danger ml-3 pointer" (click)="resetAddress()" *ngIf="addressData !== undefined && addressData && addressData.full_address"></i>
</div>